import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-api-table',
  templateUrl: './api-table.component.html',
  styleUrl: './api-table.component.scss'
})
export class ApiTableComponent {
  @Input() data: any;
  @Input() action: ((id: string| number) => void)  = ()=>{};
  @Input() loading: boolean | undefined;
  @Input() processLoading: boolean = false;
  @Input() remove: ((id: string| number) => void)  = ()=>{};
  remove_=(id: string)=>{
    // if (this.canDelete)
    this.remove(id)
  }
  constructor(){
    // console.log(this.data)
  }
  formatDate(date: string){
    const dateTimeString = date;
    const dateTime = new Date(dateTimeString);
     return dateTime.toLocaleString();
   }
  
}
